/** @format */

import React from 'react'

export function Spacer(props) {
  return (
    <div
      style={{
        flex: props.flex || 1,
      }}
    />
  )
}
